import styled from "styled-components";
const TEXTAREA = styled.textarea``;

export default TEXTAREA;
